import { Identity } from '@schibsted/account-sdk-browser/es5'
import { inject } from 'vue'
import { configInjectionKey } from '../../injectionKeys.js'

// https://schibsted.github.io/account-sdk-browser/
export const useIdentity = () => {
  const config = inject(configInjectionKey)
  const { clientId, redirectUri, env, sessionDomain } = config

  const identity = new Identity({
    clientId,
    redirectUri,
    env,
    sessionDomain,
  })

  identity.enableVarnishCookie({
    domain: document.domain,
    expiresIn: 86400,
  })

  return { identity }
}
